<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title> Maintenance Renewal</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <span>
      Request a quote for the renewal of all expired, or soon to expire, target machine and components. Maintaining your subscription ensures that your systems are fully compatible with future MathWorks software releases and enables access to
      technical support.
    </span>
    <br />
    <br />

    <form [formGroup]="form">
      <div class="form-fields">
        <!-- Renewal  Radio Button -->
        <label>Please choose a Renewal Type</label>

        <mat-radio-group required class="radio-group" formControlName="renewalType">
          @for (item of radioOptions; track item.value) {
            <mat-radio-button [value]="item.value">{{ item.name }}</mat-radio-button>
          }
        </mat-radio-group>

        <label>
          <span class="label-with-icon"> Serial number: <mat-icon ngxTippy [ngxTippy]="tippyTemplate">info</mat-icon> </span>
        </label>

        <!-- Tippy -->
        <div #tippyTemplate class="tippy-custom">
          <p>The 4 digit serial number (e.g. '1234') is printed on a sticker attached externally to your target machine. The position depends on which target machine you have and can be found in the following table:</p>
          <table class="table">
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 50%" />
            </colgroup>
            <tr>
              <th>Performance</th>
              <td>Front</td>
            </tr>
            <tr>
              <th>Mobile</th>
              <td>Side</td>
            </tr>
            <tr>
              <th>Baseline</th>
              <td>Front</td>
            </tr>
            <tr>
              <th>Unit</th>
              <td>Side</td>
            </tr>
            <tr>
              <th>Education</th>
              <td>Top, under flap</td>
            </tr>
            <tr>
              <th>Openframe</th>
              <td>Bottom</td>
            </tr>
            <tr>
              <th>Modular</th>
              <td>Side</td>
            </tr>
            <tr>
              <th>Audio</th>
              <td>Front</td>
            </tr>
          </table>
        </div>

        <!-- Select Serial Number -->
        <mat-form-field appearance="outline">
          <mat-select formControlName="serialNumber" placeholder="--Please Select--">
            @for (sn of listOfSerialNr(); track sn) {
              <mat-option [value]="sn">{{ sn }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <label>Please add any special instructions</label>
        <!-- Textarea Custom Info -->
        <mat-form-field appearance="outline">
          <textarea formControlName="instructions" matInput data-lpignore="true" autocomplete="off" placeholder="Please add any special instructions"></textarea>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <button style="width: 100%" mat-flat-button (click)="onSubmit()" [disabled]="form.invalid || saveState()">Request Maintenance Quote</button>
  </mat-card-actions>
</mat-card>
